import { useCallback } from 'react';

import useToast, { ToastTypeVariants } from './useToast';

/** Hook for copying text to the clipboard using the Clipboard API. */
export const useCopyToClipboard = () => {
  const addToast = useToast();

  const copyToClipboard = useCallback(
    async (text: string, successMessage?: string): Promise<boolean> => {
      if (!text) {
        addToast(ToastTypeVariants.ERROR, 'No text to copy');
        return false;
      }

      try {
        if (!navigator.clipboard?.writeText) {
          throw new Error('Clipboard API unavailable');
        }
        await navigator.clipboard.writeText(text);
        if (successMessage) {
          addToast(ToastTypeVariants.SUCCESS, successMessage);
        }
        return true;
      } catch {
        addToast(ToastTypeVariants.ERROR, 'Failed to copy to clipboard');
        return false;
      }
    },
    [addToast],
  );

  return copyToClipboard;
};
